import { CardListingPosition } from '@hyphengroup/cms-components/cms-blocks/CardListingPosition/CardListingPosition';
import { CardListingWrapperProps } from './types';

export const CardListingWrapperBase: React.FC<CardListingWrapperProps> = (
  props,
) => {
  return (
    <CardListingPosition
      {...props}
      skeletonThreshold={0}
      travelQuotes={undefined}
      travelPremiumsData={undefined}
    />
  );
};
